<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom faq-collection-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <h1
      v-if="title || isEditable"
      v-edit="'Title'"
      class="faq-collection-page__title"
    >
      {{ title }}
    </h1>
    <div
      v-if="preamble"
    >
      <wysiwyg
        v-if="preamble || isEditable"
        v-edit="'Preamble'"
        class="faq-collection-page__wysiwyg"
        :content="preamble"
      />
    </div>
    {{ /* TODO use faq-search component here when faq search API is ready */ }}
    <div
      v-if="faqCollection.length"
      class="faq-collection-page__nested-accordion-wrapper"
    >
      <accordion-block
        v-for="(item, index) in faqCollection"
        :key="index"
        v-no-edit
        :tracking-scope="title"
        v-bind="item"
      >
        <h4
          v-if="item.accordionsHeading"
          slot="heading"
        >
          {{ item.accordionsHeading }}
          <span class="accordion-block__heading-count">{{ item.accordionBlocks.length }} frågor</span>
        </h4>

        <template #content>
          <accordion-block
            v-for="(block, blockIndex) in item.accordionBlocks"
            :key="blockIndex"
            v-bind="block"
            :has-border="true"
            :size="56"
            :tracking-scope="item.accordionsHeading"
            class="accordion-block__sub"
          >
            <template #content>
              <wysiwyg :content="block.content" />
            </template>
          </accordion-block>
        </template>
      </accordion-block>
    </div>
    <div
      v-if="contactBlocks.length"
      v-edit="'Contactblocks'"
      class="contact-blocks-wrapper"
    >
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          class="row-1-noGutter-center_md-3 margin-gutter"
        >
          <contact-block
            v-for="(item,index) in contactBlocks"
            :key="index"
            v-bind="item"
            class="col"
          />
        </div>
      </in-view>
    </div>
    <navigation-blocks
      v-if="allNavigatablePages.length"
      :navigation-blocks="allNavigatablePages"
      :display-image-state="displayImagesInNavigationBlocks"
    >
      <sub-heading
        v-if="navigationHeading || isEditable"
        :v-edit-heading="'NavigationHeading'"
        :heading="navigationHeading"
      />
    </navigation-blocks>

    <additional-navigation-blocks
      v-if="isEditable"
      :items="additionalNavigatablePages"
    />
  </div>
</template>
<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
// TODO enable this when faq search API is ready import faqSearch from '@/vue/components/faqSearch/faqSearch'
export default {
  name : "FaqCollectionPage",
  // TODO enable this when faq search API is ready  components: {
  //   faqSearch
  // },
  mixins: [pageWithNavigation],
  props : {
    title : {
      type:String,
      default: ""
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    contactBlocks: {
      type: Array,
      default: () => []
    },
    faqCollection: {
       type: Array,
      default: () => []
    },
    preamble: {
      type: Array,
      default: () => []
    },
     displayImagesInNavigationBlocks: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style lang="scss">
  .faq-collection-page {
    &__title {
      color: $color-brown-dark;
      max-width: 57.5rem;
      margin: 1.5rem 0 1rem;

      @include font(rubrik, 7, "black");
    }

    &__nested-accordion-wrapper {
      margin: 1.5rem 0 0;

      @include media-breakpoint-up(md) {
        margin: 3rem 0 0;
      }
    }

    &__wysiwyg {
      max-width: 57.5rem;

      p {
        @include font(text,5, "light");
      }

      a {
        @include font(text,5, "bold");
      }
    }

    .accordion-block {
      &__content {
        padding: 1rem 1rem 0.5rem;

        @include media-breakpoint-up(md) {
          padding: 1.5rem 1.5rem 1rem;
        }
      }

      &__sub {
        &.accordion-block--open {
          border-left: solid 0.125rem $color-red-dark;
        }
      }

      &__heading-count {
        @include font(text,3, "normal");

        color: $color-grey-mid;
        display: block;
        margin: 0;

        @include media-breakpoint-up(md) {
          display: inline-block;
          margin-left: 10px;
        }
      }
    }

    .contact-block-wrapper {
      @include contactBlock();
    }
  }
</style>
